import { useContext } from "react";
import ServiceDetailPage from "../../ones/ServiceDetailPage";
import Footer from "../../ones/Footer";
import { AppContext } from "../../App";
import { dropdownContent } from "../../data/menuDropdowns";
import image1 from "../../assets/znz_bch.jpg";
import image2 from "../../assets/banner5.jpg";
import image3 from "../../assets/zanz_excursion.jpg";

const zanzibarRoutes = dropdownContent.zanzibar ?? [];

const zanzibarPackageMeta = {
  beach: {
    duration: "5 Days | 4 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 58%",
  },
  "stone-town": {
    duration: "4 Days | 3 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 46%",
  },
  islands: {
    duration: "6-9 Days | 5-8 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 32%",
  },
  nungwi: {
    duration: "5-7 Days | 4-6 Nights",
    travellers: "Travellers 2+",
    imagePosition: "center 48%",
  },
};

export default function ServiceSesame() {
  const appContext = useContext(AppContext);

  function handleRouteNavigation(nav) {
    if (!nav) return;
    appContext.navTo(nav);
  }

  const zanzibarPackages = zanzibarRoutes.map((card) => {
    const subItem = card.nav?.subItem || "";
    const meta = zanzibarPackageMeta[subItem] || {};

    return {
      badge: "Beach Holiday",
      title: card.title,
      description: card.text,
      duration: meta.duration || "Custom duration",
      travellers: meta.travellers || "Travellers 2+",
      image: card.img,
      imageAlt: card.title,
      imagePosition: meta.imagePosition || "center",
      nav: card.nav,
      onClick: () => handleRouteNavigation(card.nav),
      ctaLabel: "View Route",
    };
  });

  return (
    <>
      <ServiceDetailPage
        label="Zanzibar"
        title="Zanzibar Excursion"
        subtitle="Beach holiday, cultural history, and island adventure across Unguja's coastlines and Stone Town heritage."
        overview="Zanzibar is a Tanzanian archipelago off the East African coast, known for white-sand beaches, turquoise water, spice history, and deep Swahili-Islamic cultural influence. Stone Town, a UNESCO-recognized historic center, reflects centuries of Arab, Portuguese, and African exchange. The north and east coasts offer warm Indian Ocean waters framed by palms and relaxed beach resorts, making Zanzibar an ideal post-safari or post-Kilimanjaro extension. Our programs combine beach relaxation with guided excursions, water activities, and cultural experiences, with flexible itineraries that can be customized to your preferred pace and style."
        images={[
          {
            src: image1,
            subItem: "beach",
            alt: "Zanzibar beach retreat",
            captionTitle: "Zanzibar Experiences Await",
            captionText: "Powder-white beaches and warm turquoise ocean settings.",
          },
          {
            subItem: "stone-town",
            src: image2,
            alt: "Stone Town walk",
            captionTitle: "Stone Town Heritage",
            captionText: "Architecture, bazaars, and layered cultural history.",
          },
          {
            subItem: "islands",
            src: image3,
            alt: "Zanzibar excursion activities",
            captionTitle: "Island Excursions",
            captionText: "Spice farms, marine activities, and curated day experiences.",
          },
        ]}
        highlights={[
          "Beach stays, Stone Town discovery, and excursion add-ons in one itinerary.",
          "Easy extension from safari or Kilimanjaro with coordinated transfers.",
          "Accommodation styles from boutique retreats to premium coastal resorts.",
          "Custom-made island journeys tailored to your preferred experience.",
        ]}
        metrics={[
          { value: "6 Packages", label: "Beach holiday options" },
          { value: "2+", label: "Travellers per trip" },
          { value: "4-9 Days", label: "Trip duration range" },
        ]}
        packageHeading="Explore Excursions, Tours & Beach Holiday Packages"
        packages={zanzibarPackages}
        activityHeading="Zanzibar Tour Activities"
        activities={[
          {
            title: "Stone Town Tour",
            description:
              "Step into Zanzibar's historic heart with a guided walk through narrow streets, carved doors, old forts, heritage houses, and lively local markets.",
          },
          {
            title: "Spice Plantation Tour",
            description:
              "Explore the Spice Island's farms, discovering cloves, nutmeg, cinnamon, vanilla, and tropical fruits while learning their role in Zanzibar's trade legacy.",
          },
          {
            title: "Prison Island Excursion",
            description:
              "Take a short boat ride to Changuu Island to visit giant Aldabra tortoises, then enjoy optional swimming and snorkeling in clear coastal waters.",
          },
          {
            title: "Jozani Forest Tour",
            description:
              "Walk through protected forest habitat and mangrove ecosystems, with opportunities to see Zanzibar's endemic red colobus monkeys and native flora.",
          },
        ]}
        ctaLabel="Plan My Zanzibar Holiday"
      />
      {zanzibarRoutes.length > 0 && (
        <section className="MainBodySection" style={{ paddingTop: 40, paddingBottom: 60 }}>
          <div className="container">
            <div className="mx-auto text-center" style={{ maxWidth: 820 }}>
              <p className="text-uppercase" style={{ fontSize: 12, letterSpacing: 1.4, color: "#b07d2e" }}>
                Zanzibar
              </p>
              <h2 className="font-bold mb-2" style={{ color: "#132335", fontSize: "clamp(24px, 3vw, 32px)" }}>
                Explore the same cards as the TopBar dropdown
              </h2>
              <p className="mb-0" style={{ color: "#4f5f72", lineHeight: 1.6 }}>
                Every card below mirrors the headline, text, and navigation from the Zanzibar mega-dropdown.
              </p>
            </div>

            <div className="row g-4 mt-4">
              {zanzibarRoutes.map((card) => (
                <div className="col-12 col-md-6 col-xl-3" key={card.title}>
                  <article
                    className="mega-card"
                    role="button"
                    tabIndex={0}
                    aria-label={`Explore ${card.title}`}
                    onClick={() => handleRouteNavigation(card.nav)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        handleRouteNavigation(card.nav);
                      }
                    }}
                  >
                    <div className="mega-card-image" style={{ backgroundImage: `url(${card.img})` }} />
                    <div className="mega-card-overlay" />
                    <div className="mega-card-content">
                      <h6>{card.title}</h6>
                      <p>{card.text}</p>
                      <button
                        type="button"
                        className="btn btn-light btn-sm"
                        onClick={(event) => {
                          event.stopPropagation();
                          handleRouteNavigation(card.nav);
                        }}
                      >
                        View Route
                      </button>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      <Footer />
    </>
  );
}
